import { render, staticRenderFns } from "./AlterarRenovacaoDialog.vue?vue&type=template&id=177e5ba8&"
import script from "./AlterarRenovacaoDialog.vue?vue&type=script&lang=js&"
export * from "./AlterarRenovacaoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports